import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbButton, AbButtonType } from "abreact/misc/AbButton";
import { AbSize, AbSizeContext } from "abreact/misc/AbSize";
import { DialogContext } from "abreact/popup/DialogContext";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { observer } from "mobx-react";
import * as React from "react";
import { CancelSource } from "abreact/popup/AbDialog";

/**
 * Properties of the AbDialogButtonBar component.
 */

/**
 * The **DialogButtonBar** component is a container for displaying buttons, such as OK and Cancel, in an AbDialog component.
 */
export const AbDialogButtonBar = observer(props => {
  const dialogContext = React.useContext(DialogContext);
  const onOk = () => {
    if (props.onOk) {
      dialogContext?.dialogActionState?.setWaitingForPromise(true);
      props.onOk().then(shouldClose => {
        shouldClose && dialogContext?.dialogCallbacks.ok();
      }).finally(() => {
        dialogContext?.dialogActionState?.setWaitingForPromise(false);
      });
    } else {
      dialogContext?.dialogCallbacks.ok();
    }
  };
  const {
    okButton,
    okButtonProps,
    submitButton,
    submitButtonProps,
    cancelButton,
    cancelButtonProps
  } = props;
  const okLabel = typeof okButton === "string" ? okButton : AbWebResources.ok();
  const submitLabel = typeof submitButton === "string" ? submitButton : AbWebResources.ok();
  const cancelLabel = typeof cancelButton === "string" ? cancelButton : AbWebResources.cancel();
  const showSubmitButton = props.onSubmit !== undefined;
  return /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-dialog-button-bar", props), {
    "data-test-component": "ab-dialog-button-bar"
  }), /*#__PURE__*/React.createElement(AbSizeContext.Provider, {
    value: AbSize.SMALL
  }, props.children, showSubmitButton && /*#__PURE__*/React.createElement(AbButton, _extends({
    className: "ab-dialog-submit-button",
    label: submitLabel,
    type: AbButtonType.SUBMIT,
    dataTestId: "ab-dialog-submit-button",
    disabled: dialogContext?.dialogActionState?.waitingForPromise || submitButtonProps?.disabled
  }, submitButtonProps)), okButton && !showSubmitButton && /*#__PURE__*/React.createElement(AbButton, _extends({
    className: "ab-dialog-ok-button",
    label: okLabel,
    dataTestId: "ab-dialog-ok-button",
    type: AbButtonType.PRIMARY,
    onClick: onOk,
    disabled: !!dialogContext?.dialogActionState?.waitingForPromise || okButtonProps?.disabled
  }, okButtonProps)), cancelButton && /*#__PURE__*/React.createElement(AbButton, _extends({
    className: "ab-dialog-cancel-button",
    label: cancelLabel,
    dataTestId: "ab-dialog-cancel-button",
    onClick: () => dialogContext?.dialogCallbacks.cancel(CancelSource.CANCEL_BUTTON),
    disabled: dialogContext?.dialogActionState?.waitingForPromise
  }, cancelButtonProps))));
});
//# sourceMappingURL=AbDialogButtonBar.js.map
